import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom'
import headerLogo from '../../images/foodsby-logo-menu.png'
import { formatUrl } from '../../util/formatUtils'
import {
  rootRoute,
  loginRoute,
  logoutRoute,
  locationRoute
} from '../../routes/routes'
import { connect } from 'react-redux'
import { revertTemporaryLocation } from '../../redux/modules/user'
import { AdminMenu } from './AdminMenu.js'
import cn from 'classnames'
import LinkPopup from './LinkPopup'
import LoginOrJoin from '../login/LoginOrJoin'
const FOODSBY_BASE_URL = process.env.REACT_APP_FOODSBY_BASE_URL

export class HeaderDropdown extends Component {
  state = { dropdownOpen: false }

  handleHeaderNameClick = () => {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }))
  }

  handleHeaderItemClick = e => {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }))
    if (this.props.originalLocationId) {
      this.props.revertTemporaryLocation(this.props.originalLocationId)
    }
  }

  handleClickOutside = e => {
    if (this.wrapper && !this.wrapper.contains(e.target)) {
      this.setState({ dropdownOpen: false })
    }
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }
  render() {
    const {
      menuItems,
      username,
      isadmin,
      locationId,
      requestCount,
      originalLocationId
    } = this.props
    return (
      <nav
        ref={node => (this.wrapper = node)}
        className="dropdown header-dropdown"
        style={{ outline: 'none' }}
      >
        <ul>
          <li>
            <button
              className="link"
              style={{ paddingRight: '28px' }}
              onClick={this.handleHeaderNameClick}
              id="username"
            >
              {username}
            </button>
            <ul
              className="left"
              style={
                !this.state.dropdownOpen
                  ? { display: 'none' }
                  : { display: 'block', width: '200px' }
              }
            >
              {locationId ? (
                <li>
                  <Link
                    onClick={this.handleHeaderItemClick}
                    to={
                      originalLocationId
                        ? formatUrl(locationRoute.path, {
                            locationId: originalLocationId
                          })
                        : formatUrl(locationRoute.path, {
                            locationId: locationId
                          })
                    }
                  >
                    My Home
                  </Link>
                </li>
              ) : null}
              {menuItems !== null &&
                menuItems.map((menu, index) => (
                  <li key={index}>
                    <Link onClick={this.handleHeaderItemClick} to={menu.link}>
                      {menu.text === 'Friends' && (
                        <Fragment>
                          &nbsp;
                          <i className="icon-users">
                            {requestCount && requestCount > 0 ? (
                              <span className="friendRequestBadge">
                                {requestCount}
                              </span>
                            ) : null}
                            {/* if the null isn't passed here from the terinary a 0 shows up next to the friends label if there are no incoming requests which we don't want */}
                          </i>
                          &nbsp;
                        </Fragment>
                      )}
                      {menu.text}
                    </Link>
                  </li>
                ))}
              <li className="divider" />
              <li>
                <Link to={logoutRoute.path}>Log Out</Link>
              </li>
              {isadmin ? <AdminMenu /> : ''}
            </ul>
          </li>
        </ul>
      </nav>
    )
  }
}

const HeaderLinks = () => (
  <nav className="header-inner_public desktop">
    <a href={`${FOODSBY_BASE_URL}/main/business/`}>For Businesses</a>
    <a href={`${FOODSBY_BASE_URL}/main/restaurants/`}>For Restaurants</a>
    <a href={`${FOODSBY_BASE_URL}/main/faqs/`}>FAQs</a>
    <a href={`${FOODSBY_BASE_URL}/main/contact/`}>Contact</a>
  </nav>
)

const Header = ({
  isAuthenticated,
  currentUser,
  locationId,
  isCurrentUserLoading,
  menuItems,
  classNames,
  showLinks,
  requestCount,
  revertTemporaryLocation,
  match = {}
}) => {
  return (
    <header className={cn({ header: true, ...classNames })}>
      <div className="header-inner">
        {isAuthenticated && locationId ? (
          <Link
            to={formatUrl(locationRoute.path, { locationId: locationId })}
            className="header-logo"
            style={{ marginLeft: '3px' }}
          >
            <img
              src={headerLogo}
              alt="Foodsby – Lunch delivery solved for office professionals"
              height="76"
            />
          </Link>
        ) : !isAuthenticated && !locationId && showLinks ? (
          <a
            className="header-logo"
            style={{ marginLeft: '3px' }}
            href={`${FOODSBY_BASE_URL}/main/`}
          >
            <img
              src={headerLogo}
              alt="Foodsby – Lunch delivery solved for office professionals"
              height="76"
            />
          </a>
        ) : (
          <Link
            to={rootRoute.path}
            className="header-logo"
            style={{ marginLeft: '3px' }}
          >
            <img
              src={headerLogo}
              alt="Foodsby – Lunch delivery solved for office professionals"
              height="76"
            />
          </Link>
        )}
        {isAuthenticated && currentUser ? (
          <HeaderDropdown
            requestCount={requestCount}
            locationId={locationId}
            menuItems={menuItems}
            username={currentUser.email}
            isadmin={currentUser.isAdmin}
            originalLocationId={currentUser.originalLocationId}
            revertTemporaryLocation={revertTemporaryLocation}
          />
        ) : !showLinks ? (
          <nav className="dropdown header-dropdown" key={2}>
            <ul>
              <li>
                {match.params && match.params.locationId ? (
                  <LinkPopup
                    linkText={
                      <Fragment>
                        <i className="icon-user" id="login" /> Login
                      </Fragment>
                    }
                    maxWidth="1024px"
                  >
                    <LoginOrJoin
                      loginTitle="Login"
                      joinTitle="Register"
                      loginMessage="Login and get lunch to your office."
                      signupMessage="Sign up and get lunch to your office."
                      path={window.location.pathname}
                      locationId={match.params.locationId}
                    />
                  </LinkPopup>
                ) : (
                  <a href={loginRoute.path}>
                    <i className="icon-user" id="login" /> Login
                  </a>
                )}
              </li>
            </ul>
          </nav>
        ) : (
          !isCurrentUserLoading && [
            <HeaderLinks key={1} />,
            <nav className="dropdown header-dropdown" key={2}>
              <ul>
                <li>
                  <a href={loginRoute.path}>
                    <i className="icon-user" id="login" /> Login
                  </a>
                </li>
              </ul>
            </nav>
          ]
        )}
      </div>
    </header>
  )
}

function mapStateToProps(state) {
  const { currentUser } = state.user

  return {
    currentUser
  }
}

const mapDispatchToProps = {
  revertTemporaryLocation
}

Header.defaultProps = {
  menuItems: []
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header)
